import { Box, CircularProgress, styled, Typography } from "@mui/material";
import FileSaver from "file-saver";
import React, { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { toastError } from "../../../_utils/toastError";
import { getEnvWithoutAPI } from "../../../Utils";

const PDFButton: React.FC<{
  type: string;
  token: string;
  personId: string;
  typeName: string;
  fullName: string;
  label: string;
  datePassed?: string;
}> = ({ type, token, personId, fullName, typeName, label, datePassed }) => {
  const [loading, setLoading] = useState(false);
  const onDownload = async () => {
    if (loading) return;
    try {
      setLoading(true);
      await downloadPdf({ type, token, personId, fullName, typeName });
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <BoxClickable onClick={onDownload}>
      <Icon>
        {loading ? (
          <CircularProgress size={15} />
        ) : (
          <DownloadIcon sx={{ width: 18, height: 18 }} color="primary" />
        )}
      </Icon>

      <Box display="flex" justifyContent={"space-between"} width="100%">
        <Typography
          color="primary"
          variant="body2"
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "120px",
          }}
        >
          {label}
        </Typography>
        <Typography color="#8F9BB3" variant="body2">
          {datePassed}
        </Typography>
      </Box>
    </BoxClickable>
  );
};

export default PDFButton;

const downloadPdf = async ({
  type,
  token,
  personId,
  fullName,
  typeName,
}: {
  type: string;
  token: string;
  personId: string;
  typeName: string;
  fullName: string;
}) => {
  const dlUrl: any = process.env.REACT_APP_PDF_URL;
  const locale = "fr";

  // Remplace "dynamics" par "inc" pour l'API
  const apiType = type === "dynamics" ? "inc" : type;

  const params = `token=${token}&apiUrl=${getEnvWithoutAPI()}&personId=${personId}&locale=${locale}`;
  try {
    const res = await fetch(`${dlUrl}/api/${apiType}?${params}`, {
      method: "GET",
      headers: { "Content-Type": "blob" },
    });

    if (!res.ok) throw new Error("Invalid file");

    const myBlob = await res.blob();
    const blob2 = new Blob([myBlob], { type: "application/pdf" });

    const fileName = `${fullName}_${typeName}.pdf`;

    FileSaver.saveAs(blob2, fileName);
  } catch (err) {
    toastError();
  }
};

const Icon = styled(Box)(({ theme }: any) => ({
  borderRadius: "25px",
  width: 22,
  height: 22,
  background: theme.palette.primary[500_12],
  marginRight: theme.spacing(1),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const BoxClickable = styled(Box)(({ theme }: any) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: theme.palette.primary[500_12],
    borderRadius: "8px",
  },
}));
